import { CIcon } from '~/icons/types'

export const ciListOrdered: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M10 7h11a1 1 0 1 0 0-2H10a1 1 0 0 0 0 2Zm11 4H10a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2Zm0 6H10a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2ZM6 9V6a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2v2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm-.008 4.139c-.7-.434-1.613-.445-2.439-.032a1 1 0 0 0 .895 1.789c.223-.11.408-.107.493-.057.018.011.06.037.064.12-.05.173-.464.588-.711.835C3.687 16.398 3 17.087 3 18a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-.087C6.458 16.445 7 15.812 7 15c0-.787-.368-1.466-1.008-1.861Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'list-ordered',
  type: 'regular'
}
